import { IInitAction } from './init'
import { IQuery } from './search'
import { IPublishedGraphicBasic } from './publishedGraphic'

// Action types
export enum types {
  PUBLISHED_SEARCH_PACKS__STARTED = 'PUBLISHED_SEARCH_PACKS__STARTED',
  PUBLISHED_SEARCH_PACKS__SUCCESS = 'PUBLISHED_SEARCH_PACKS__SUCCESS',
  PUBLISHED_SEARCH_PACKS__FAILURE = 'PUBLISHED_SEARCH_PACKS__FAILURE',
  UPDATE_PUBLISHED_SKIP_QUERY = 'UPDATE_PUBLISHED_SKIP_QUERY',
  RESET_PUBLISHED_SEARCH = 'RESET_PUBLISHED_SEARCH',
}

export interface IPublishedSearchPacksAction {
  type: types.PUBLISHED_SEARCH_PACKS__STARTED
  query: IQuery
}

export interface IPublishedSearchPacksSuccessAction {
  type: types.PUBLISHED_SEARCH_PACKS__SUCCESS
  items: IPublishedGraphicBasic[]
  totalCount: number
}

export interface IPublishedFailureAction {
  type: types.PUBLISHED_SEARCH_PACKS__FAILURE
  message: string
}

export interface IUpdatePublishedSkipQuery {
  type: types.UPDATE_PUBLISHED_SKIP_QUERY
  skip: number
}

export interface IResetPublishedSearchAction {
  type: types.RESET_PUBLISHED_SEARCH
}

export type PublishedSearchActionsType =
  | IPublishedSearchPacksAction
  | IPublishedSearchPacksSuccessAction
  | IPublishedFailureAction
  | IUpdatePublishedSkipQuery
  | IResetPublishedSearchAction
  | IInitAction

// Reducer types

export interface IPublishedSearch {
  isLoading: boolean
  items: IPublishedGraphicBasic[]
  totalCount: number
  skip: number
  groupId?: string
}
